
export const ROUTES = {
  home: '/',
  loadingPlans: '/loading-plans',
  createLoadingPlan: '/loading-plans/create',
  updateLoadingPlan: '/loading-plans/:loadingPlanId',
  viewLoadingPlan: '/loading-plans/view/:loadingPlanId',
  sharedViewLoadingPlan: '/loading-plans/shared/view/:loadingPlanId',
  handPartsInclusion: '/loading-plans/hand-parts-inclusion/:loadingPlanId',
  authTest: '/auth-test',
}
